import { apiClient } from 'modules/apiClient';
import { User } from '../types';

const getMe = async (): Promise<User> => {
  const response = await apiClient.get('/v1/users/me');
  return response.data;
};

export const UserApi = { getMe };
